import axios from 'axios';
import store from '../store';

const CancelToken = axios.CancelToken.source();

const authReq = () => axios.create({
  baseURL: '/api/v2',
  headers: {
    Authorization: `Bearer ${store.state.auth.token}`,
    'X-Business-ID':
      store.state.activeBusiness && store.state.activeBusiness.id,
  },
});

const req = () => axios.create({
  baseURL: '/api/v2',
});

const interceptors = [];

const callApi = (endpoint, data = {}, method = 'get', auth = true) => new Promise((resolve, reject) => {
  const sendData = ['get', 'options'].includes(method) ? { params: data } : Array.isArray(data) ? data : { ...data };
  const request = auth ? authReq() : req();

  interceptors.forEach((interceptor) => {
    request.interceptors.response.use(
      interceptor.onResponse,
      interceptor.onError,
    );
  });

  request[method](endpoint, sendData, {
    cancelToken: CancelToken.token,
  })
    .then((res) => resolve(res.data))
    .catch((err) => {
      if (err.response) {
        return reject(err.response.data);
      }
      // We would normally reject with an Error object here
      // But we use destructuring to display error toaster
      // and the message object is lost in the process
      // Return a direct object with message and title properties
      return reject(new Error('Please check your internet connection and try again.'));
    });
});

export default {
  authReq(endpoint, data = {}, method = 'get') {
    return callApi(endpoint, data, method);
  },
  req(endpoint, data = {}, method = 'get') {
    return callApi(endpoint, data, method, false);
  },
  interceptors,
  CancelToken,
  isCancel(err) {
    return axios.isCancel(err);
  },
};
